/**
 * staging environment
 */
export const isStag = process.env.REACT_APP_ENV === 'STAGING';
